import {
    getMultiSelectMessage,
    getReqMessage,
    getSelectMessage
} from '../../../utils/formValidation/errorMessageFunctions';

export const validateAttendanceStatuses = (attendanceStatuses, errors) => {
    if (!attendanceStatuses || attendanceStatuses?.length < 1)
        return {
            ...errors,
            attendanceStatuses: { error: true, message: getMultiSelectMessage('attendance status') }
        };
    return errors;
};

export const validateDate = (date, errors) => {
    if (!date) {
        return {
            ...errors,
            date: { error: true, message: getReqMessage('Date') }
        };
    }
    return errors;
};

export const validateContract = (contract, errors) => {
    if (!contract || Object.keys(contract).length < 1)
        return {
            ...errors,
            contract: { error: true, message: getSelectMessage('contract') }
        };
    return errors;
};

export const validateService = (service, errors) => {
    if (!service || Object.keys(service).length < 1)
        return {
            ...errors,
            service: { error: true, message: getSelectMessage('service') }
        };
    return errors;
};

export const validateServiceId = (serviceId, errors) => {
    if (!serviceId)
        return {
            ...errors,
            serviceId: { error: true, message: getSelectMessage('service') }
        };
    return errors;
};

export const validateTeamIds = (teamIds, errors) => {
    if (!teamIds || teamIds?.length < 1)
        return {
            ...errors,
            teamIds: { error: true, message: getMultiSelectMessage('team') }
        };
    return errors;
};
